<template>
  <div class="exercise-muscles" :class="{ 'exercise-muscles--small': small }">
    <div class="exercise-muscles__figures" :aria-label="interactive ? 'Muskelgruppen auswählen' : 'Beanspruchte Muskelgruppen'">
      <div><object ref="front" type="image/svg+xml" data="/img/einmalig/humanSVGFrontPlanRun.svg" aria-label="Muskeln von vorne" @load="initialise('front')" @error="failed = true"><span>Vorderansicht</span></object><small>Vorne</small></div>
      <div><object ref="back" type="image/svg+xml" data="/img/einmalig/humanSVGBackPlanRun.svg" aria-label="Muskeln von hinten" @load="initialise('back')" @error="failed = true"><span>Rückansicht</span></object><small>Hinten</small></div>
    </div>
    <p v-if="failed" class="exercise-muscles__fallback">Die Muskelgrafik ist gerade nicht verfügbar. Die Auswahl unten funktioniert weiterhin.</p>
  </div>
</template>
<script>
import api from "@/api"
let catalogRequest = null
function tagCatalog() {
  if (!catalogRequest) catalogRequest = api.fetchExerciseTags().catch(error => { catalogRequest = null; throw error })
  return catalogRequest
}
export default {
  props: { tags: { type: Array, default: () => [] }, selected: { type: Array, default: () => [] }, interactive: Boolean, small: Boolean },
  data: () => ({ catalog: [], failed: false }),
  computed: { mappedTags() { return this.tags.map(tag => ({ ...tag, class: tag.class || this.catalog.find(item => (item._id && item._id === tag._id) || item.name === tag.name)?.class })).filter(tag => tag.class && tag.class !== 'unselectable') } },
  watch: { mappedTags: { deep: true, handler() { this.paint() } }, selected() { this.paint() }, tags() { this.loadCatalog() } },
  created() { this._svgListeners = {}; this.loadCatalog() },
  beforeDestroy() { this._disposed = true; Object.values(this._svgListeners).forEach(item => item.document.removeEventListener("click", item.click)); this._svgListeners = {} },
  methods: {
    async loadCatalog() {
      if (!this.tags.some(tag => !tag.class)) return
      try { const catalog = await tagCatalog(); if (!this._disposed) this.catalog = Array.isArray(catalog) ? catalog : [] } catch (_) { /* Named filters remain available without the catalog. */ }
    },
    initialise(side) {
      try {
        const document = this.$refs[side]?.getSVGDocument()
        if (!document?.documentElement || document.documentElement.localName !== "svg") { this.failed = true; return }
        const previous = this._svgListeners[side]
        if (previous) previous.document.removeEventListener("click", previous.click)
        const click = event => {
          if (!this.interactive) return
          let target = event.target
          while (target && target !== document) {
            const tag = this.mappedTags.find(tag => target.classList?.contains(tag.class))
            if (tag) { this.$emit("select", tag.key); return }
            target = target.parentNode
          }
        }
        document.documentElement.style.cssText = "width:100%;height:100%;background:transparent;"
        document.addEventListener("click", click)
        this._svgListeners[side] = { document, click, painted: new Map() }
        this.paint()
      } catch (_) { this.failed = true }
    },
    paint() {
      const accent = this.$vuetify?.theme?.themes?.dark?.primary || "#00963f"
      for (const { document, painted } of Object.values(this._svgListeners || {})) {
        // Preserve the original figure, outlines and background. Only muscles
        // resolved from Roody's exercise tags receive a different fill.
        for (const [element, original] of painted) { element.style.fill = original.fill; element.style.cursor = original.cursor }
        painted.clear()
        const ordered = [...this.mappedTags].sort((a, b) => Number(this.selected.includes(a.key)) - Number(this.selected.includes(b.key)))
        for (const tag of ordered) for (const element of Array.from(document.getElementsByClassName(tag.class))) {
          const selected = this.selected.includes(tag.key)
          for (const shape of [element, ...element.querySelectorAll("path, polygon, rect, ellipse, circle")]) {
            if (!painted.has(shape)) painted.set(shape, { fill: shape.style.fill, cursor: shape.style.cursor })
            shape.style.fill = selected ? accent : this.interactive ? "#849287" : "#414641"
            shape.style.cursor = this.interactive ? "pointer" : "default"
          }
        }
      }
    },
  },
}
</script>
<style scoped>
.exercise-muscles__figures { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; max-width: 340px; margin: 0 auto; }
.exercise-muscles__figures > div { min-width: 0; text-align: center; }
.exercise-muscles object { display: block; height: 210px; width: 100%; }
.exercise-muscles small { display: block; color: #999f99; font-size: 10px; margin: 6px 0 0; }
.exercise-muscles--small object { height: 160px; }
.exercise-muscles__fallback { font-size: 12px; color: #b1b6b1; margin: 12px 0 0; }
</style>
